import { useMemo } from "react";
import { AttributeDefinitionDc } from "@evergis/api";

import { useCurrentLayerDefinition } from "./useCurrentLayer";

export const useCurrentLayerAttributes = (): { [key: string]: AttributeDefinitionDc } => {
  const layerDefinition = useCurrentLayerDefinition();

  return useMemo(() => layerDefinition && layerDefinition.attributes, [layerDefinition]);
};

export const useCurrentLayerAttributeNames = (): string[] => {
  const attributes = useCurrentLayerAttributes();

  return useMemo(() => (attributes ? Object.keys(attributes) : []), [attributes]);
};
